import axios from "axios"

export const pastEvents = () => axios.get("/api/v2/events?direction=past")

export const futureEvents = () => axios.get("/api/v2/events?direction=future")

export const get = (id) => axios.get(`/api/v2/events/${id}`)

export const rsvpData = (ids) =>
  Promise.all([
    axios.get("/api/v2/account/event_rsvps", {
      params: {
        event_ids: ids
      }
    }),
    axios.get("/api/v2/events/rsvps", {
      params: {
        event_ids: ids
      }
    })
  ])

export const rsvpUpdate = ({ id, value }) =>
  axios.put(`/api/v2/events/${id}/rsvp`, {
    value
  })

export const goingUsers = ({ id, page }) =>
  axios.get(`/api/v2/events/${id}/going_users`, {
    params: {
      page
    }
  })

export const isLivestreamAvailable = (id) => axios.get(`/api/v2/events/${id}/livestream_availability`)
